window.addEventListener("DOMContentLoaded", () => {
    resizeProductBanners();
    moveAnouncementOnMobileView();
    window.addEventListener("resize", () => {
        resizeProductBanners();
        moveAnouncementOnMobileView();
    })
})

function resizeProductBanners() {
    let productBannerElements = document.querySelectorAll(".product-block__custom-banner--wrapper img");
    if (productBannerElements) {
        productBannerElements.forEach((element) => {
            let firstProductCard = element.closest(".products-grid").querySelector(".product .product-item");
            if (firstProductCard) {
                element.style.height = firstProductCard.clientHeight + "px";
            }
        })
    }
}
function moveAnouncementOnMobileView() {
  let windowWidth = window.innerWidth;
  let indexPage = document.body.classList.contains('template-index');
  let landingPage = document.querySelector('.template-page section .landing-page');
  let announcementBar = document.querySelector(".section-header-advanced");
  let desktopHeader = document.querySelector(".section-header-navigation");
  let mobileHeader = document.querySelector(".section-header-mobile");
    if (!indexPage) {
      if (landingPage == null) {
        if (windowWidth <= 1024) {
            announcementBar.setAttribute("moved", "");
            mobileHeader.after(announcementBar);
            announcementBar.style.zIndex = 19;
        } else if (windowWidth >= 1025 && announcementBar.hasAttribute("moved")) {
            announcementBar.removeAttribute("moved");
            desktopHeader.before(announcementBar);
            announcementBar.style.zIndex = 21;

        }
      }
    }
}

function checkForDifferenceInProductCompare() {
    /* # Digiloop - added highlighting function for different values in a single line */
    let firstRowContent = [];
    document.querySelectorAll(".compare-difference").forEach((element) => {
        element.classList.remove("compare-difference");
    });
    // Add compare difference classes
    document.querySelectorAll(".compareTable tbody .compareTable-row").forEach((element, index) => {
        if (index == 0) {
            element.querySelectorAll(".compareTable-item").forEach((elem) => firstRowContent.push(elem.innerHTML.trim()));                          
        } else {
            element.querySelectorAll(".compareTable-item").forEach((elem, index) => {                           
                if (firstRowContent[index] != elem.innerHTML.trim()) {
                    document.querySelectorAll(".compareTable tbody .compareTable-row").forEach((row) => row.querySelectorAll(".compareTable-item")[index].classList.add("compare-difference"));
                    // document.querySelectorAll(".compareTable thead th")[index].classList.add("compare-difference");
                }
            });
        }
    })
    // Resize overflowing elements
    let rowSizeMax = new Array(document.querySelectorAll(".compareTable .compareTable-row")[1].querySelectorAll(".compareTable-item").length + 1).fill(-1);
    document.querySelectorAll(".compareTable .compareTable-row").forEach((column) => {
      column.querySelectorAll("td").forEach((cell, index) => {
        let hasSplittedText = cell.querySelector(".compareTable-item__tag--row")
        if (hasSplittedText) {
          let maxContentHeight = cell.querySelectorAll(".compareTable-item__tag--row").length * hasSplittedText.offsetHeight + 20;
          if (maxContentHeight > rowSizeMax[index])
            rowSizeMax[index] = maxContentHeight;
        }
      });
    })
    rowSizeMax.forEach((height, heightIndex) => {
       if (height != -1) {
         document.querySelectorAll(".compareTable .compareTable-row").forEach((element, index) => {
           if (index == 0) {
             element.querySelectorAll(".compareTable-heading")[heightIndex - 1].style.height = height + "px";
             element.querySelectorAll(".compareTable-heading")[heightIndex - 1].style.paddingTop = "10px";
             element.querySelectorAll(".compareTable-heading")[heightIndex - 1].style.paddingBottom = "10px";
           } else {
             element.querySelectorAll(".compareTable-item")[heightIndex - 1].style.height = height + "px";
             element.querySelectorAll(".compareTable-item")[heightIndex - 1].style.paddingTop = "10px";
             element.querySelectorAll(".compareTable-item")[heightIndex - 1].style.paddingBottom = "10px";
           }
         })
       }
    })
}